<script lang="ts">
  import StopInfo from "./StopInfo.svelte";
  import RefreshFeed from "./RefreshFeed.svelte";

  let lastUpdated = 0;
  let lang = document.location.search.indexOf("lang=fr") > -1 ? "fr" : "en"

  
  // resizeObserver fires when heights change
  const resizeObserver = new ResizeObserver((entries) => {
    const message: any = {
      height: entries[0].target.clientHeight,
      width: document.body.scrollWidth,
      id: entries[0].target.id,
    };
    window.top.postMessage(message, "*");
  });

  // start observing a DOM node
  setTimeout(() => {
    resizeObserver.observe(document.querySelector("#shuttle-wrapper"));
  }, 100);

  let apiURL: string = "https://nimbus.wialon.com/api/depot/6043/stop/";

  const apiKey: string = "Token 524caf7041ad4fb7966f6f754d868ad5";

  let stopInfo: any = {
    en: 
    [{
      name: "Airport Pick Up/Drop Off",
      address: "2 Eireann Quay, Toronto",
      lat: 43.634196834581225,
      lng: -79.39717782417243,
      stopId: 411445,
    },
    {
      name: "Union Station Pick Up/Drop Off",
      address: "100 Front Street West, Toronto",
      lat: 43.646342477114906,
      lng: -79.38116868784545,
      stopId: 411447,
    }],
    fr: [{
      name: "Prise en charge et retour à l’aéroport",
      address: "2 Eireann Quay, Toronto",
      lat: 43.634196834581225,
      lng: -79.39717782417243,
      stopId: 411445,
    },
    {
      name: "Prise en charge et retour à la gare Union",
      address: "100, rue Front ouest, Toronto",
      lat: 43.646342477114906,
      lng: -79.38116868784545,
      stopId: 411447,
    }]
  }


  let lastUpdate: Date;

  let apiData = {
    loaded: false,
    lastUpdate: 0,
    loading: false,
    error: false,
    data: {
      stop_411445: {
        time: "...",
        eta: "...",
        dist: "",
        stationDistance: { eta: 0 },
      },
      stop_411447: {
        time: "...",
        eta: "...",
        dist: "",
        stationDistance: { eta: 0 },
      },
    },
  };

  function useTestData() {
    let newData = {};

    newData = Object.assign({}, apiData.data, {
      stop_411445: {
        time: "...",
        eta: "...",
        dist: "",
        stationDistance: { eta: 0 },
      },
      stop_411447: {
        time: "...",
        eta: "...",
        dist: "",
        stationDistance: { eta: 0 },
      },
    });

    const newApiData = Object.assign({}, apiData, {
      loading: false,
      loaded: true,
      data: newData,
    });
    apiData = newApiData;
  }

  function formatLastUpdate() {
    let d: Date = new Date();

    if (lastUpdate) {
      return Math.floor((d - lastUpdate) / 1000 / 60);
    }
    return "n/a";
  }

  async function loadAllShuttles() {
    loadShuttleData(411445);
    loadShuttleData(411447);
  }

  function formatTime(tm) {
    let proxy = new Date();
    let updatedTime = proxy.getTime();
    updatedTime += 1000 * tm;
    let d = new Date(updatedTime);

    let hours = d.getHours();
    let minutes = d.getMinutes();

    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    let ampm = "AM";

    if (hours >= 12) {
      ampm = "PM";
    }

    if (hours > 12) {
      hours -= 12;
    }

    return hours + ":" + minutes + " " + ampm;
  }

  function calcEta(tm, tm2 = null) {
    if (tm2) {
      tm += tm2;
    }

    const eta = Math.floor(tm / 60 + 0.99);

    return eta + " min" + (eta === 1 ? "" : "s");
  }

  async function loadShuttleData(stopId) {
    if (window.location.search.indexOf("test=true", 0) > -1) {
      useTestData();
      return;
    }
    apiData.loading = true;
    const headers = new Headers({
      Authorization: apiKey,
    });

    const response = await fetch(apiURL + stopId + "/panel", {
      headers: headers,
      method: "GET",
    });

    let data = await response.json();

    if (data) {
      let newData = {};
      const defaultValue = 0;
      let tm = defaultValue;
      let dist = defaultValue;
      let etaText = defaultValue;
      let id;

      data.r.forEach((curr) => {
        if (curr.tt && curr.tt.length > 0) {
          curr.tt.forEach((currShuttle) => {
            if (currShuttle.eta && currShuttle.eta.tt) {
              tm = currShuttle.eta.tt;
              etaText = currShuttle.eta.tt;

              dist = etaText;
            }
          });
        }
      });

      let obj = {};
      obj["stop_" + stopId] = {
        time: formatTime(tm),
        eta: calcEta(etaText),
        tm: tm,

        dist: calcEta(etaText),
        id: id,
      };

      newData = Object.assign({}, apiData.data, obj);

      const newApiData = Object.assign({}, apiData, {
        error:
          tm === undefined
            ? "The shuttle bus tracker encountered an error."
            : null,
        loading: false,
        loaded: true,
        data: newData,
      });

      apiData = newApiData;
    } else {
      // display error?
      let errorText = "Unable to Load";

      if (
        data.errors &&
        data.errors.error &&
        data.errors.error[0].description
      ) {
        errorText = "No currently scheduled shuttles.";
      }
      // at least show a state that says 'no flight info'
      const newApiData = Object.assign({}, apiData, {
        loading: false,
        loaded: true,
        error: false,
        data: { error: errorText },
      });
      apiData = newApiData;
    }

    lastUpdate = new Date();
  }

  setInterval(() => {
    loadAllShuttles();
  }, 10000);

  setInterval(() => {
    lastUpdated = formatLastUpdate(lastUpdate);
  }, 1000);

  loadAllShuttles();
</script>

<main>
  {#if apiData.data === null}
    <div>...</div>
  {:else}
    <div class="_w-full d-flex flx-col flx-jstretch" id="shuttle-wrapper">
      <div class="flxc-grow">
        <div>
          {#if apiData.error !== undefined && apiData.error !== false && apiData.error !== null}
            <div class="heading5 txt-center my-6">{apiData.error}</div>
          {:else}
            <svelte:component
              this={StopInfo}
              stopInfo={stopInfo[lang][0]}
              nextShuttle={apiData.data.stop_411445}
              otherShuttle={apiData.data.stop_411447}
              formatEta={calcEta}
              lang={lang}
            />
            <svelte:component
              this={StopInfo}
              stopInfo={stopInfo[lang][1]}
              nextShuttle={apiData.data.stop_411447}
              otherShuttle={apiData.data.stop_411445}
              formatEta={calcEta}
              lang={lang}
            />
            <svelte:component
              this={RefreshFeed}
              lastUpdate={lastUpdated}
              lang={lang}
              {loadAllShuttles}
            />
          {/if}
        </div>
      </div>
    </div>
  {/if}
</main>

<style global lang="postcss">
  /* @tailwind base;

  @tailwind components;
  @tailwind utilities; */

  .hide-scrollbars {
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
  }
  .hide-scrollbars::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
</style>
